import React from 'react';
import { useHistory } from 'react-router';
import {
  TableCell,
  Tooltip,
  IconButton,
  TableRow
} from '@material-ui/core';
import { format } from 'date-fns';
import { TextFormattedNumber } from 'components';
import { EditIcon } from 'components/CustomSVG';
import { convertUTCDateToLocalDate } from 'helpers/date';
import { depositStatus } from './helpers';


const formatDate = (date) => {
  return date
    ? (
      <>
        <div>{format(date, 'MM/dd/yyyy')}</div>
        <div>{format(date, 'hh:mm:ss aa')}</div>
      </>
    )
    : null;
};

const DepositsTableRow = ({ depositData, headTableCells }) => {
  const history = useHistory();
  const {
    entity_id,
    order_id,
    firstname,
    lastname,
    deposit,
    interval_price,
    billing_interval,
    length,
    run_count,
    last_run,
    next_run,
    status,
    created_at,
    email
  } = depositData;

  const columns = headTableCells.reduce((acc, column) => {
    acc[column.label] = column;

    return acc;
  }, {});

  const nextRunDate = next_run ? convertUTCDateToLocalDate(next_run) : '';
  const lastRunDate = last_run ? convertUTCDateToLocalDate(last_run) : '';
  const createdDate = created_at ? convertUTCDateToLocalDate(created_at) : '';

  return (
    <TableRow>
      {columns['Order ID']?.display && <TableCell align="center">{order_id}</TableCell>}
      {columns['First Name']?.display && <TableCell align="center">{firstname}</TableCell>}
      {columns['Last Name']?.display && <TableCell align="center">{lastname}</TableCell>}
      {columns['Customer Email']?.display && <TableCell className="whitespace-no-wrap" align="center">{email}</TableCell>}
      {columns['Created']?.display &&
        <TableCell align="center">
          {formatDate(createdDate)}
        </TableCell>
      }
      {columns['Last Run']?.display &&
        <TableCell align="center">
          {formatDate(lastRunDate)}
        </TableCell>
      }
      {columns['Next Run']?.display &&
        <TableCell align="center">
          {formatDate(nextRunDate)}
        </TableCell>
      }

      {columns['Deposit']?.display &&
        <TableCell align="center">
          <TextFormattedNumber
            value={deposit}
            prefix="$"
          />
        </TableCell>
      }
      {columns['Interval Price']?.display &&
        <TableCell align="center">
          <TextFormattedNumber
            value={interval_price}
            prefix="$"
          />
        </TableCell>
      }

      {columns['Interval (days)']?.display &&
        <TableCell align="center">{billing_interval}</TableCell>
      }

      {columns['Times Billed']?.display &&
        <TableCell align="center">{run_count} / {length}</TableCell>
      }

      {columns['Status']?.display &&
        <TableCell align="center">
          <span className={`whitespace-no-wrap ${status} ${status ? 'indicator' : null}`}>
            {status ? depositStatus[status] : ''}
          </span>
        </TableCell>
      }

      {columns['Action']?.display &&
        <TableCell align="center">
          <Tooltip title="Edit">
            <IconButton
              onClick={() => history.push(`/deposits/edit/${entity_id}/${order_id}`)}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      }
    </TableRow>
  );
};

export default DepositsTableRow;
